import React, { useState, useEffect } from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Divider,
    Chip,
    IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SchoolIcon from "@mui/icons-material/School";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import PeopleIcon from "@mui/icons-material/People";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AutoPopUp from "./AutoPopUp";

import antheBanner1 from "../assets/anthe/banner1.png";
import antheBanner2 from "../assets/anthe/banner2.png";
import antheBanner3 from "../assets/anthe/banner3.png";
import antheBanner4 from "../assets/anthe/banner4.png";
import antheLogo from "../assets/anthe/anthe.png";

const banners = [antheBanner1, antheBanner3, antheBanner4];

const AnthePage = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const [activeSlide, setActiveSlide] = useState(0);

    const [isAutoPopupOpen, setIsAutoPopupOpen] = useState(false);
    
    const handleOpenAutoPopup = () => {
        const formSubmitted = sessionStorage.getItem("isFormSubmited");
        if (!formSubmitted) {
            setIsAutoPopupOpen(true);
        }
    };

    const handleCloseAutoPopup = () => {
        setIsAutoPopupOpen(false);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            handleOpenAutoPopup();
        }, 11000);

        return () => clearTimeout(timeout)
    }, [])
    
    useEffect(() => {
        const timer = setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % banners.length);
        }, 4000);
        return () => clearInterval(timer);
    }, []);

    const goTo = (idx) => setActiveSlide((idx + banners.length) % banners.length);

    const examDetails = [
        {
            icon: <AccessTimeIcon sx={{ fontSize: 32, color: "#00AEEF" }} />,
            title: "Online Exam Timing",
            line1: "27th Oct – 01st Nov",
            line2: "10 AM – 10 PM",
            note: "Take the exam anytime during the login window from the comfort of home.",
        },
        {
            icon: <CalendarTodayIcon sx={{ fontSize: 32, color: "#00AEEF" }} />,
            title: "Offline Exam Timing",
            line1: "9th, 11th & 25th Oct & 1st Nov",
            line2: "10:30 AM – 11:30 AM",
            note: "At your nearest designated Aakash examination centre.",
        },
        {
            icon: <SchoolIcon sx={{ fontSize: 32, color: "#00AEEF" }} />,
            title: "Eligibility",
            line1: "Open to students currently studying in:",
            line2: "Class V, VI, VII, VIII, IX, X, XI, XII",
            note: "",
        },
    ];

    const howToRegister = [
        { step: "1", title: "Enter details", desc: "Enter your name and mobile number and submit your application." },
        { step: "2", title: "Submit your details", desc: "Fill in the short online form and submit your application." },
        { step: "3", title: "Registration successful", desc: "Get your admit card and login details to start preparing." },
    ];

    const scholarshipInfo = [
        { mode: "OFFLINE EXAM", pct: "Up to 100%", desc: "Scholarship on course fees", color: "#003087" },
        { mode: "ONLINE EXAM", pct: "Up to 80%", desc: "Scholarship on tuition fees", color: "#00AEEF" },
    ];

    const toppers = [
        { name: "Mridul Manya Anand", rank: "AIR 1 NEET 2024", batch: "ANTHE 2020", img: "https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/student/MridulManyaAnand.webp" },
        { name: "Ayush Naugraiya", rank: "AIR 1 NEET 2024", batch: "ANTHE 2021", img: "https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/student/AyushNaugraiya.webp" },
        { name: "Utkarsh Awadhiya", rank: "AIR 2 NEET 2025", batch: "ANTHE 2021", img: "https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/student/UtkarshAwadhiya.webp" },
        { name: "Krishang Joshi", rank: "AIR 3 NEET 2025", batch: "ANTHE 2022", img: "https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/student/KrishangJoshi.webp" },
        { name: "Uplakshya Goyal", rank: "AIR 3 NEET 2026", batch: "ANTHE 2023", img: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/pdf_management_files/target_solutions/Uplakshya%20Goyal-00009069892.webp" },
        { name: "Mohit Shekhar", rank: "AIR 4 JEE 2026", batch: "ANTHE 2021", img: "https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/pdf_management_files/target_solutions/Mohit%20Shekhar%20Shukla.webp" },
        { name: "Harsh Kedawat", rank: "AIR 9 NEET 2025", batch: "ANTHE 2023", img: "https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/student/HarshKedawat.webp" },
        { name: "Rujul Garg", rank: "AIR 41 JEE 2025", batch: "ANTHE 2022", img: "https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/student/RujulGarg.webp" },
    ];

    const faqData = [
        { question: "What is the last date of registration?", answer: "For Offline Mode, registration closes 7 days before the examination date. For Online Mode, registration closes 3 days before the examination date." },
        { question: "What is the exam pattern of ANTHE 2026?", answer: "For Classes V–VI: 40 questions for 80 marks. For Classes VII–XII: 40 questions for 90 marks. Duration: 1 hour. No negative marking." },
        { question: "How much scholarship can I get through ANTHE?", answer: "Students appearing through Offline Mode can get up to 100% scholarship on course fee. Students appearing through Online Mode can get up to 80% scholarship on Tuition Fees only." },
        { question: "Can a 5th-class student register for ANTHE?", answer: "Yes, a student currently studying in Class 5 can register for ANTHE and shall be eligible for next academic year's courses." },
        { question: "Which courses can I get a scholarship on through ANTHE?", answer: "ANTHE gives students up to 100%* Scholarship on Medical (NEET), Engineering (JEE), and Foundation Classroom and Aakash Digital courses." },
        { question: "Can a student give the exam on a Mobile Phone or Tablet?", answer: "Yes, students can take the ANTHE exam on a mobile phone, tablet, laptop, or desktop computer with a stable internet connection." },
        { question: "Is there negative marking in ANTHE?", answer: "No, there is no negative marking in ANTHE. You can attempt all questions without any risk." },
    ];

    return (
        <Box sx={{ bgcolor: "#f5f7fa", minHeight: "100vh", mt: { xs: 7, md: 14 } }}>

            {/* ── HERO ── */}
            <Box
                sx={{
                    background: "linear-gradient(135deg, #0a1f6e 0%, #1040a0 40%, #1a7ac8 75%, #00AEEF 100%)",
                    py: { xs: 4, md: 5 },
                    px: 2,
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* subtle radial glow top-right */}
                <Box sx={{
                    position: "absolute", top: -80, right: -80,
                    width: 400, height: 400, borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(0,174,239,0.25) 0%, transparent 70%)",
                    pointerEvents: "none",
                }} />

                <Container maxWidth="lg">
                    <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">

                        {/* ── LEFT — logo, title, stats, CTA ── */}
                        <Grid item xs={12} md={7}>

                            {/* Logo + Title */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 2, md: 3 }, mb: 3 }}>
                                <Box
                                    component="img"
                                    src={antheLogo}
                                    alt="ANTHE"
                                    sx={{
                                        width: { xs: 85, md: 155 },
                                        objectFit: "contain",
                                        flexShrink: 0,
                                        filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.3))",
                                    }}
                                />
                                <Box>
                                    <Typography sx={{ color: "white", fontWeight: 900, fontSize: { xs: "2rem", md: "3.5rem" }, lineHeight: 1.2, letterSpacing: -0.5 }}>
                                        ANTHE 2026
                                    </Typography>
                                    <Typography sx={{ color: "white", fontWeight: 600, fontSize: { xs: "0.95rem", md: "1.2rem" }, mt: 0.5 }}>
                                        Talent Ka{" "}
                                        <Box component="span" sx={{ color: "#FFD700", fontWeight: 800 }}>Sabse Bada Exam</Box>
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Stats strip */}
                            <Box
                                sx={{
                                    bgcolor: "rgba(255,255,255,0.1)",
                                    border: "1px solid rgba(255,255,255,0.18)",
                                    borderRadius: 2.5,
                                    px: { xs: 1.5, md: 2.5 },
                                    py: { xs: 1.5, md: 2 },
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 3,
                                }}
                            >
                                {[
                                    { val: "1 Crore+*", label: "STUDENTS\nREGISTERED" },
                                    { val: "100%*",     label: "SCHOLARSHIP"          },
                                    { val: "₹2.5 Cr*", label: "CASH AWARDS"          },
                                    { val: "🏆",        label: "ALL INDIA RANK"       },
                                ].map((s, i, arr) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            flex: 1,
                                            textAlign: "center",
                                            px: { xs: 0.5, md: 1 },
                                            borderRight: i < arr.length - 1 ? "1px solid rgba(255,255,255,0.2)" : "none",
                                            py: 0.5,
                                        }}
                                    >
                                        <Typography sx={{ color: "#FFD700", fontWeight: 900, fontSize: { xs: "0.95rem", md: "1.25rem" }, lineHeight: 1.1 }}>
                                            {s.val}
                                        </Typography>
                                        <Typography sx={{ color: "rgba(255,255,255,0.72)", fontSize: { xs: "0.55rem", md: "0.6rem" }, fontWeight: 700, letterSpacing: 0.4, mt: 0.4, whiteSpace: "pre-line" }}>
                                            {s.label}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                            {/* Apply CTA */}
                            <Button
                                variant="contained"
                                size="large"
                                onClick={() => setOpenPopup(true)}
                                sx={{
                                    bgcolor: "#FFD700",
                                    color: "#003087",
                                    fontWeight: 800,
                                    fontSize: { xs: "0.9rem", md: "1rem" },
                                    px: { xs: 4, md: 5 },
                                    py: 1.5,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    boxShadow: "0 4px 18px rgba(255,215,0,0.4)",
                                    "&:hover": { bgcolor: "#ffc400", transform: "translateY(-2px)", boxShadow: "0 6px 22px rgba(255,215,0,0.55)" },
                                    transition: "all 0.25s",
                                }}
                            >
                                Apply Now — Free
                            </Button>
                        </Grid>

                        {/* ── RIGHT — Exam Dates ── */}
                        <Grid item xs={12} md={5}>
                            <Box
                                sx={{
                                    bgcolor: "rgba(255,255,255,0.1)",
                                    border: "1px solid rgba(255,255,255,0.2)",
                                    borderRadius: 3,
                                    p: { xs: 2.5, md: 3.5 },
                                    backdropFilter: "blur(8px)",
                                }}
                            >
                                {/* Header */}
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2.5 }}>
                                    <CalendarTodayIcon sx={{ fontSize: 16, color: "#FFD700" }} />
                                    <Typography sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.7rem", fontWeight: 700, letterSpacing: 1.8, textTransform: "uppercase" }}>
                                        Exam Dates
                                    </Typography>
                                </Box>

                                {/* Date rows */}
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                                    {[
                                        {
                                            icon: "🖥",
                                            mode: "Online exams:",
                                            date: "27th Oct - 1st Nov 2026",
                                            note: "10 AM – 10 PM",
                                        },
                                        {
                                            icon: "📋",
                                            mode: "Offline exams:",
                                            date: "9th, 11th, 25th Oct & 1st Nov 2026",
                                            note: "10:30 AM – 11:30 AM",
                                        },
                                    ].map((d, i) => (
                                        <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                                            <Box
                                                sx={{
                                                    width: 38, height: 38, borderRadius: 2,
                                                    bgcolor: "rgba(255,255,255,0.12)",
                                                    border: "1px solid rgba(255,255,255,0.2)",
                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                    fontSize: "1.1rem", flexShrink: 0,
                                                }}
                                            >
                                                {d.icon}
                                            </Box>
                                            <Box>
                                                <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, mb: 0.2 }}>
                                                    {d.mode}
                                                </Typography>
                                                <Typography sx={{ color: "white", fontWeight: 800, fontSize: { xs: "0.88rem", md: "0.95rem" } }}>
                                                    {d.date}
                                                </Typography>
                                                <Typography sx={{ color: "#FFD700", fontSize: "0.75rem", fontWeight: 600, mt: 0.2 }}>
                                                    {d.note}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>

                                {/* <Chip
                                    label="Registrations Open 2026-27 · Aakash Yelahanka"
                                    sx={{
                                        mt: 3,
                                        bgcolor: "rgba(255,215,0,0.15)",
                                        color: "#FFD700",
                                        border: "1px solid rgba(255,215,0,0.35)",
                                        fontWeight: 600,
                                        fontSize: "0.7rem",
                                        width: "100%",
                                        borderRadius: 2,
                                    }}
                                /> */}
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </Box>
            {/* ── BANNER SLIDER — simple ── */}
            <Box sx={{ bgcolor: "#d6edf8", py: { xs: 2, md: 3 }, px: { xs: 2, md: 26 } }}>
                <Container maxWidth="lg">
                    <Box sx={{ position: "relative" }}>
                        {/* track */}
                        <Box sx={{ overflow: "hidden", borderRadius: 3 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    transition: "transform 0.5s ease",
                                    transform: `translateX(-${activeSlide * 100}%)`,
                                }}
                            >
                                {banners.map((img, i) => (
                                    <Box
                                        key={i}
                                        component="img"
                                        src={img}
                                        alt={`ANTHE Banner ${i + 1}`}
                                        sx={{
                                            width: "100%",
                                            flexShrink: 0,
                                            height: { xs: 180, sm: 260, md: 470 },
                                            objectFit: "cover",
                                            display: "block",
                                            borderRadius: 3,
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>

                        {/* prev arrow */}
                        <IconButton
                            onClick={() => goTo(activeSlide - 1)}
                            sx={{
                                position: "absolute", top: "50%", left: -18,
                                transform: "translateY(-50%)",
                                bgcolor: "white", color: "#003087",
                                width: 36, height: 36,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                "&:hover": { bgcolor: "#f0f0f0" },
                            }}
                        >
                            <ArrowBackIosNewIcon sx={{ fontSize: 15 }} />
                        </IconButton>

                        {/* next arrow */}
                        <IconButton
                            onClick={() => goTo(activeSlide + 1)}
                            sx={{
                                position: "absolute", top: "50%", right: -18,
                                transform: "translateY(-50%)",
                                bgcolor: "white", color: "#003087",
                                width: 36, height: 36,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                "&:hover": { bgcolor: "#f0f0f0" },
                            }}
                        >
                            <ArrowForwardIosIcon sx={{ fontSize: 15 }} />
                        </IconButton>
                    </Box>

                    {/* dots + counter */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, mt: 1.5 }}>
                        {banners.map((_, i) => (
                            <Box
                                key={i}
                                onClick={() => setActiveSlide(i)}
                                sx={{
                                    width: i === activeSlide ? 16 : 7,
                                    height: 7,
                                    borderRadius: 4,
                                    bgcolor: i === activeSlide ? "#003087" : "rgba(0,48,135,0.25)",
                                    cursor: "pointer",
                                    transition: "width 0.3s",
                                }}
                            />
                        ))}
                        {/* <Typography sx={{ fontSize: "0.7rem", color: "#003087", fontWeight: 600, ml: 0.5 }}>
                            {activeSlide + 1}/{banners.length}
                        </Typography> */}
                    </Box>
                </Container>
            </Box>


            {/* ── EXAM DETAILS ── */}
            <Container maxWidth="lg" sx={{ py: { xs: 5, md: 7 } }}>
                <Typography variant="overline" sx={{ display: "block", textAlign: "center", color: "#00AEEF", fontWeight: 700, letterSpacing: 2, mb: 0.5 }}>
                    EXAM DETAILS
                </Typography>
                <Typography variant="h4" sx={{ textAlign: "center", fontWeight: 800, color: "#003087", mb: 1, fontSize: { xs: "1.5rem", md: "2rem" } }}>
                    Everything you need to plan ahead
                </Typography>
                <Typography variant="body1" sx={{ textAlign: "center", color: "#666", mb: 5, maxWidth: 520, mx: "auto" }}>
                    Clear schedule, eligibility and timing so you can prepare with confidence.
                </Typography>
                <Grid container spacing={3}>
                    {examDetails.map((item, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Box
                                sx={{
                                    bgcolor: "white",
                                    borderRadius: 3,
                                    p: 3.5,
                                    height: "80%",
                                    boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                                    border: "1px solid #e8eef6",
                                    transition: "all 0.3s",
                                    "&:hover": { boxShadow: "0 8px 28px rgba(0,48,135,0.12)", borderColor: "#00AEEF", transform: "translateY(-3px)" },
                                }}
                            >
                                <Box sx={{ mb: 2 }}>{item.icon}</Box>
                                <Typography variant="h6" sx={{ fontWeight: 700, color: "#003087", mb: 1 }}>{item.title}</Typography>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: "#222", mb: 0.5 }}>{item.line1}</Typography>
                                <Typography variant="body2" sx={{ color: "#00AEEF", fontWeight: 700, mb: 1 }}>{item.line2}</Typography>
                                {item.note && <Typography variant="body2" sx={{ color: "#777", lineHeight: 1.7 }}>{item.note}</Typography>}
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            {/* ── SCHOLARSHIP STRIP ── */}
            {/* <Box sx={{ bgcolor: "#003087", py: { xs: 5, md: 6 } }}>
                <Container maxWidth="lg">
                    <Typography variant="overline" sx={{ display: "block", textAlign: "center", color: "#FFD700", fontWeight: 700, letterSpacing: 2, mb: 0.5 }}>
                        LIMITED TIME — REGISTER NOW
                    </Typography>
                    <Typography variant="h4" sx={{ textAlign: "center", fontWeight: 800, color: "white", mb: 1, fontSize: { xs: "1.5rem", md: "2rem" } }}>
                        Secure up to 100%* Scholarship
                    </Typography>
                    <Typography variant="body1" sx={{ textAlign: "center", color: "rgba(255,255,255,0.7)", mb: 5 }}>
                        on Medical, Engineering &amp; Foundation courses
                    </Typography>
                    <Grid container spacing={3} justifyContent="center">
                        {scholarshipInfo.map((s, i) => (
                            <Grid item xs={12} sm={5} key={i}>
                                <Box
                                    sx={{
                                        bgcolor: "rgba(255,255,255,0.1)",
                                        border: `2px solid ${s.color === "#FFD700" ? "#FFD700" : "rgba(255,255,255,0.2)"}`,
                                        borderRadius: 3,
                                        p: { xs: 3, md: 4 },
                                        textAlign: "center",
                                        transition: "transform 0.3s",
                                        "&:hover": { transform: "translateY(-5px)", bgcolor: "rgba(255,255,255,0.15)" },
                                    }}
                                >
                                    <Typography variant="overline" sx={{ color: "rgba(255,255,255,0.65)", letterSpacing: 2, fontWeight: 700 }}>
                                        {s.mode}
                                    </Typography>
                                    <Typography variant="h2" sx={{ color: "#FFD700", fontWeight: 900, fontSize: { xs: "2.5rem", md: "3rem" }, my: 1 }}>
                                        {s.pct}
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.82)", fontWeight: 500 }}>{s.desc}</Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                    <Box sx={{ textAlign: "center", mt: 4 }}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => setOpenPopup(true)}
                            sx={{
                                bgcolor: "#FFD700", color: "#003087", fontWeight: 800,
                                px: 5, py: 1.5, borderRadius: 2, textTransform: "none",
                                "&:hover": { bgcolor: "#ffc400", transform: "translateY(-2px)" },
                                transition: "all 0.25s",
                            }}
                        >
                            Register Now — It's Free
                        </Button>
                    </Box>
                </Container>
            </Box> */}

            {/* ── HOW TO REGISTER ── */}
            <Container maxWidth="lg" sx={{ py: { xs: 5, md: 7 } }}>
                <Typography variant="overline" sx={{ display: "block", textAlign: "center", color: "#00AEEF", fontWeight: 700, letterSpacing: 2, mb: 0.5 }}>
                    REGISTRATION
                </Typography>
                <Typography variant="h4" sx={{ textAlign: "center", fontWeight: 800, color: "#003087", mb: 1, fontSize: { xs: "1.5rem", md: "2rem" } }}>
                    How to Register
                </Typography>
                <Typography variant="body1" sx={{ textAlign: "center", color: "#666", mb: 5 }}>
                    Three simple steps to secure your spot in ANTHE 2026
                </Typography>
                <Grid container spacing={3} justifyContent="center">
                    {howToRegister.map((item, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Box
                                sx={{
                                    bgcolor: "white", borderRadius: 3, p: 4, textAlign: "center",
                                    boxShadow: "0 2px 16px rgba(0,0,0,0.07)", border: "1px solid #e8eef6",
                                    transition: "all 0.3s",
                                    "&:hover": { boxShadow: "0 8px 28px rgba(0,48,135,0.12)", borderColor: "#00AEEF" },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 54, height: 54, borderRadius: "50%",
                                        background: "linear-gradient(135deg, #003087, #00AEEF)",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        mx: "auto", mb: 2.5,
                                    }}
                                >
                                    <Typography sx={{ color: "white", fontWeight: 900, fontSize: "1.3rem" }}>{item.step}</Typography>
                                </Box>
                                <Typography variant="h6" sx={{ fontWeight: 700, color: "#003087", mb: 1 }}>{item.title}</Typography>
                                <Typography variant="body2" sx={{ color: "#666", lineHeight: 1.7 }}>{item.desc}</Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            {/* ── WALL OF FAME ── */}
            <Box sx={{ bgcolor: "white", py: { xs: 5, md: 7 } }}>
                <Container maxWidth="lg">
                    <Typography variant="overline" sx={{ display: "block", textAlign: "center", color: "#00AEEF", fontWeight: 700, letterSpacing: 2, mb: 0.5 }}>
                        WALL OF FAME
                    </Typography>
                    <Typography variant="h4" sx={{ textAlign: "center", fontWeight: 800, color: "#003087", mb: 1, fontSize: { xs: "1.5rem", md: "2rem" } }}>
                        Be the next topper
                    </Typography>
                    <Typography variant="body1" sx={{ textAlign: "center", color: "#666", mb: 5, maxWidth: 520, mx: "auto" }}>
                        Our scholars are leading from the front in India's most competitive exams.
                    </Typography>
                    <Grid container spacing={2.5} justifyContent="center">
                        {toppers.map((t, i) => (
                            <Grid item xs={6} sm={3} md={3} key={i}>
                                <Box
                                    sx={{
                                        textAlign: "center", p: 2, borderRadius: 3,
                                        border: "1px solid #eef2f8",
                                        transition: "all 0.3s",
                                        "&:hover": { boxShadow: "0 8px 24px rgba(0,48,135,0.12)", borderColor: "#00AEEF", transform: "translateY(-4px)" },
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={t.img}
                                        alt={t.name}
                                        sx={{
                                            width: { xs: 70, md: 90 }, height: { xs: 70, md: 90 },
                                            borderRadius: "50%", objectFit: "cover",
                                            border: "3px solid #00AEEF", mb: 1.5,
                                        }}
                                    />
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: "#003087", fontSize: "0.78rem", mb: 0.5 }}>{t.name}</Typography>
                                    <Chip label={t.rank} size="small" sx={{ bgcolor: "#003087", color: "white", fontSize: "0.6rem", fontWeight: 600, height: 20, mb: 0.5 }} />
                                    <Typography variant="caption" sx={{ display: "block", color: "#888", fontSize: "0.65rem" }}>{t.batch}</Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                    <Box sx={{ textAlign: "center", mt: 5 }}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => setOpenPopup(true)}
                            sx={{
                                background: "linear-gradient(135deg, #003087, #00AEEF)",
                                color: "white", fontWeight: 700, px: 5, py: 1.5,
                                borderRadius: 2, textTransform: "none",
                                "&:hover": { opacity: 0.9, transform: "translateY(-2px)" },
                                transition: "all 0.25s",
                            }}
                        >
                            Register for ANTHE 2026
                        </Button>
                    </Box>
                </Container>
            </Box>

            {/* ── FAQ ── */}
            <Container maxWidth="md" sx={{ py: { xs: 5, md: 7 } }}>
                <Typography variant="overline" sx={{ display: "block", textAlign: "center", color: "#00AEEF", fontWeight: 700, letterSpacing: 2, mb: 0.5 }}>
                    FAQS
                </Typography>
                <Typography variant="h4" sx={{ textAlign: "center", fontWeight: 800, color: "#003087", mb: 1, fontSize: { xs: "1.5rem", md: "2rem" } }}>
                    Frequently Asked Questions
                </Typography>
                <Typography variant="body1" sx={{ textAlign: "center", color: "#666", mb: 5 }}>
                    Quick answers to what students ask most
                </Typography>
                {faqData.map((faq, i) => (
                    <Accordion
                        key={i}
                        sx={{
                            mb: 1.5, "&:before": { display: "none" },
                            boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                            borderRadius: "10px !important", overflow: "hidden",
                            border: "1px solid #eef2f8",
                        }}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#00AEEF" }} />} sx={{ "&:hover": { bgcolor: "#f0f7ff" }, py: 0.5 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#003087" }}>{faq.question}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ pt: 0 }}>
                            <Divider sx={{ mb: 1.5 }} />
                            <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8 }}>{faq.answer}</Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Container>

            {/* ── GET IN TOUCH ── */}
            <Box sx={{ background: "linear-gradient(135deg, #003087 0%, #005EB8 100%)", py: { xs: 5, md: 7 } }}>
                <Container maxWidth="md" sx={{ textAlign: "center" }}>
                    <Typography variant="overline" sx={{ display: "block", color: "#FFD700", fontWeight: 700, letterSpacing: 2, mb: 0.5 }}>
                        GET IN TOUCH
                    </Typography>
                    <Typography variant="h4" sx={{ color: "white", fontWeight: 800, mb: 1, fontSize: { xs: "1.5rem", md: "2rem" } }}>
                        We're here to help you
                    </Typography>
                    <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.72)", mb: 5, maxWidth: 480, mx: "auto" }}>
                        Have questions about registration, scholarships or exam patterns? Our team is ready.
                    </Typography>
                    <Grid container spacing={3} justifyContent="center">
                        {[
                            { icon: <LocalPhoneIcon sx={{ fontSize: 26, color: "#FFD700" }} />, label: "CALL US (TOLL FREE)", value: "+91 7026505152", href: "tel:7026505152" },
                            { icon: <EmailIcon sx={{ fontSize: 26, color: "#FFD700" }} />, label: "EMAIL SUPPORT", value: "corporate@aesl.in", href: "mailto:corporate@aesl.in" },
                        ].map((c, i) => (
                            <Grid item xs={12} sm={6} key={i}>
                                <Box
                                    component="a"
                                    href={c.href}
                                    sx={{
                                        display: "flex", alignItems: "center", gap: 2,
                                        bgcolor: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)",
                                        borderRadius: 3, px: 3, py: 2.5, textDecoration: "none",
                                        transition: "all 0.25s",
                                        "&:hover": { bgcolor: "rgba(255,215,0,0.15)", borderColor: "#FFD700" },
                                    }}
                                >
                                    <Box sx={{ width: 48, height: 48, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                        {c.icon}
                                    </Box>
                                    <Box sx={{ textAlign: "left" }}>
                                        <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.6)", textTransform: "uppercase", letterSpacing: 1, display: "block" }}>{c.label}</Typography>
                                        <Typography variant="h6" sx={{ color: "white", fontWeight: 700 }}>{c.value}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => setOpenPopup(true)}
                        sx={{
                            mt: 5, bgcolor: "#FFD700", color: "#003087", fontWeight: 800,
                            px: 6, py: 1.6, borderRadius: 2, textTransform: "none", fontSize: "1rem",
                            "&:hover": { bgcolor: "#ffc400", transform: "translateY(-2px)" },
                            transition: "all 0.25s",
                            boxShadow: "0 4px 20px rgba(255,215,0,0.35)",
                        }}
                    >
                        Apply for ANTHE Now 
                    </Button>
                </Container>
            </Box>
            <AutoPopUp
                isOpen={isAutoPopupOpen}
                onClose={handleCloseAutoPopup}
                leadFlag="Organic"
            />
        </Box>
    );
};

export default AnthePage;
